<template>
  <section>
    <form class="search-form" @submit.prevent="">
      <label class="input-cont">
        <search-icon class="icon"></search-icon>
        <input type="text" v-model="filter" :placeholder="$t('users.thingSearch')">
      </label>
    </form>

    <ul class="permissions-list" >
      <li class="permission-item">
        <div class="item-top" @click="openThings = !openThings">
          <p class="permission-title">
            {{$t('btns.users.things')}}
          </p>
          <chevron-icon :fill="'#109CF1'" :class="{'opened': openThings}"></chevron-icon>
        </div>
        <transition name="fade">
          <ul class="things-list" v-show="openThings">
            <role-info-thing v-for="item in thingsList"
                             :thing="item"
                             :list="thingsList"
                             :key="item.id"></role-info-thing>
          </ul>
        </transition>
      </li>

      <li class="permission-item">
        <div class="item-top" @click="openProjects = !openProjects">
          <p class="permission-title">
            {{$t('menu.projects')}}
          </p>
          <chevron-icon :fill="'#109CF1'" :class="{'opened': openProjects}"></chevron-icon>
        </div>
        <transition name="fade">
          <ul class="projects-list" v-show="openProjects">
            <role-info-project v-for="item in projectsList"
                               :project="item"></role-info-project>
          </ul>
        </transition>
      </li>
    </ul>
  </section>
</template>

<script>
  import chevronIcon from '../../Svg/chevronIcon'
  import {mapState} from 'vuex'
  import {tokenAndRoute} from "../../../mixins/utils/tokenAndRoute";
  import {filters} from "../../../mixins/filters";
  import roleInfoThing from './infoBlocks/roleInfoThing'
  import {searchFormInfo} from "../../../mixins/searchFormInfo";
  import roleInfoProject from './infoBlocks/roleInfoProject'

  export default {
    name: 'roleInfoPermissions',
    mixins: [tokenAndRoute, filters,searchFormInfo],
    components: {
      chevronIcon,
      roleInfoThing,
      roleInfoProject
    },
    data() {
      return {
        openThings: false,
        openProjects: false
      }
    },
    computed: {
      ...mapState({
        things: state => state.things.ownedThing,
        projects: state => state.projects.allProjects
      }),
      thingsList() {
        let arrThings = [];

        let roleId = this.routeId;
        let devices = this.things;

        function findInDevices(arr) {
          findItem(arr);

          function findItem(a) {
            for (let  i = 0; i < a.length; i++) {
              let item = a[i];
              if (item.permissions) {
                for (let j = 0; j < item.permissions.length; j++) {
                  let permission = item.permissions[j];
                  if (permission.role_id == roleId) {
                    arrThings.push({
                      name: item.name,
                      level: permission.value,
                      id: item.id,
                      permissions: item.permissions
                    })
                  }
                }
                ;
              }
              if (item.included_devices && item.included_devices.length > 0) {
                findItem(item.included_devices)
              }
            }
          }
        };
        findInDevices(devices);

        arrThings = this.delDouble(arrThings, 'id');
        arrThings = arrThings.filter(item => {
          let filter = this.filter.toLowerCase();
          if (String(item.name).toLowerCase().includes(filter)) {
            return item
          }
        });

        return arrThings
      },
      projectsList() {
        let arrProjects = [];
        let roleId = this.routeId;

        let projects = this.projects;

        function findInProjects(arr) {
          findItem(arr);

          function findItem(a) {
            for (let item of a) {
              if (item.permissions) {
                for (let permission of item.permissions) {
                  if (permission.role_id == roleId) {
                    let obj = {
                      name: item.name,
                      level: permission.value,
                      id: item.id,
                      permission: item.permissions
                    };
                    if (item.owner_role_id) {
                      obj.parent = true;
                    } else {
                      obj.parent = false;
                    };
                    arrProjects.push(obj)
                  }
                }
              };

              if (item.items && item.items.length > 0) {
                findItem(item.items)
              }
            }
          }
        };

        findInProjects(projects);
        arrProjects = this.delDouble(arrProjects, 'id');
        arrProjects = arrProjects.filter(item => {
          let filter = this.filter.toLowerCase();
          if (String(item.name).toLowerCase().includes(filter)) return item
        });

        return arrProjects

      }
    }
  }
</script>

<style lang="scss" scoped>
  .search-form {
    position: relative;
    width: calc(100% + 60px);
    margin-left: -30px;
    margin-bottom: 30px;

    .icon {
      position: absolute;
      left: 30px;
      top: 0;
      background: none;
      width: 20px;
    }
  }

  .permission-title {
    font-family: $mm;
    font-size: 14px;
    letter-spacing: .25px;
    opacity: .5;
    cursor: pointer;
    user-select: none;
  }

  .item-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 22px;
    padding: 0 20px;
    padding-right: 30px;

    svg {
      cursor: pointer;
      transition: $anim;
    }

    .opened {
      transform: rotate(180deg);
    }
  }
</style>
